import { useEffect } from 'react';

/**
 *
 * This will prevent installation popup(Add to home screen) PWA
 */
const DisableA2HS = () => {
  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  return null;
};

export default DisableA2HS;
